import type { DistributionChannel } from './distributionChannel.ts';
import type { ConstValues } from './helpers.ts';
import type { ObjectType } from './objectTypes.ts';
import type { Revshare } from './revshare.ts';

export const AdUnitDeliveryMedium = {
  LINEARVIDEO: 'LINEARVIDEO',
  MOBILE: 'MOBILE',
  NONLINEARVIDEO: 'NONLINEARVIDEO',
  WEB: 'WEB',
} as const;
export type AdUnitDeliveryMedium = ConstValues<typeof AdUnitDeliveryMedium>;

export const AdUnitType = {
  LINEARVIDEO: 'adunit.linearvideo',
  MOBILE: 'adunit.mobile',
  NATIVE: 'adunit.native',
  NONLINEARCTV: 'adunit.nonlinearctv',
  WEB: 'adunit.web',
} as const;
export type AdUnitType = ConstValues<typeof AdUnitType>;

export const AdPlacement = {
  Banner: 'BANNER',
  Video: 'VIDEO',
  Native: 'NATIVE',
  CTV: 'CTV',
} as const;
export type AdPlacement = ConstValues<typeof AdPlacement>;

export interface AdUnitBase {
  account_id: string;
  account_uid: string;
  ad_placement: AdPlacement;
  alt_sizes: string | null;
  delivery_medium?: AdUnitDeliveryMedium;
  distribution_channel: DistributionChannel;
  divid: string | null;
  divid_match_type: 'EXACT' | 'CONTAINS' | 'STARTSWITH' | null;
  fallback_ad_tag: string | null;
  id: string;
  instance_uid: string;
  modified_date: string;
  name: string;
  presentation_format: string;
  primary_size: string | null;
  real_time_bid_floor: string | null;
  site_id: string;
  site_uid: string;
  status: string;
  tagid: string | null;
  tagid_match_type: 'EXACT' | 'CONTAINS' | 'STARTSWITH' | null;
  type: typeof ObjectType.Adunit;
  type_full: AdUnitType;
  uid: string;
}

export interface AdUnit extends AdUnitBase {
  api_frameworks?: string[] | null;
  autorefresh_settings: Record<string, { max: string; delay: string; country: string }> | null;
  content_topics: { [key: number]: boolean } | null;
  content_type: string | null;
  duration?: string;
  is_rewarded?: string;
  is_vast_test_mode?: string;
  linearity?: string;
  location: string | null;
  maxbitrate?: string | null;
  mime_types?: string[];
  minbitrate?: string | null;
  playbackmethods?: string[] | null;
  pos?: string;
  protocols?: string[];
  revshare: Revshare;
}

export interface AdUnitApi extends AdUnitBase {
  api_frameworks: string[] | null;
  autorefresh_settings: Record<string, { max: string; delay: string; country: string }> | null;
  content_topics: { [key: number]: boolean } | null;
  content_type: string | null;
  duration: string;
  external_id: string;
  is_rewarded: string;
  is_vast_test_mode: string;
  linearity?: string;
  location: string | null;
  maxbitrate: string | null;
  mime_types: string[];
  minbitrate: string | null;
  playbackmethods: string[] | null;
  pos?: string;
  protocols: string[];
  revshare: Revshare;
  tag_type?: string;
  yield_optimization?: string;
}

export const AdUnitStatus = {
  Active: 'Active',
  Inactive: 'Inactive',
} as const;
export type AdUnitStatus = ConstValues<typeof AdUnitStatus>;
